const initFeaturedCollectionCarousel = (emblaComponent) => {
  if (!emblaComponent.classList.contains('featured-collection__carousel')) return;

  const syncStaticState = () => {
    const emblaApi = emblaComponent.emblaApi;
    if (!emblaApi) return;

    const isStatic = !emblaApi.canScrollPrev() && !emblaApi.canScrollNext();
    const wasStatic = emblaComponent.classList.contains('featured-collection__carousel--static');

    emblaComponent.classList.toggle('featured-collection__carousel--static', isStatic);

    if (isStatic === wasStatic) return;

    emblaApi.reInit({
      watchDrag: !isStatic,
    });
  };

  const waitForApi = () => {
    if (!emblaComponent.emblaApi) {
      requestAnimationFrame(waitForApi);
      return;
    }

    syncStaticState();
    emblaComponent.emblaApi.on('reInit', syncStaticState);
    emblaComponent.emblaApi.on('resize', syncStaticState);
  };

  waitForApi();
};

const initFeaturedCollectionCarousels = (root = document) => {
  root
    .querySelectorAll('embla-component.featured-collection__carousel')
    .forEach(initFeaturedCollectionCarousel);
};

document.addEventListener('DOMContentLoaded', () => initFeaturedCollectionCarousels());

document.addEventListener('shopify:section:load', (event) => {
  const section = document.querySelector(`#shopify-section-${event.detail.sectionId}`);
  if (section) initFeaturedCollectionCarousels(section);
});
